const slides = [
  {
    title: '探花精选 · 夏日限定合集',
    desc: '七月盛夏特别策划的探花精选合集，汇聚本月最受欢迎的热门内容与独家推荐，为您打造一站式浏览体验。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20golden%20summer%20abstract%20landscape%20with%20soft%20amber%20gradients%20and%20gentle%20light%20rays%2C%20elegant%20flowing%20organic%20shapes%2C%20luxurious%20warm%20atmosphere%2C%20cinematic%20wide%20composition%2C%20rich%20textured%20background%2C%20no%20text%2C%20no%20people%2C%20abstract%20fine%20art&width=1200&height=600&seq=carousel-tanhua-summer&orientation=landscape',
    tag: '限时专题',
  },
  {
    title: '经典回顾 · 探花百年珍藏',
    desc: '探花在线多年积累的经典内容大回顾，从早期珍品到近年精品，完整梳理探花资源发展脉络，值得每位探花爱好者收藏。',
    img: 'https://readdy.ai/api/search-image?query=Deep%20burgundy%20and%20dark%20amber%20cinematic%20wide%20composition%2C%20vintage%20luxurious%20aesthetic%20with%20rich%20velvet%20textures%2C%20dramatic%20contrast%20lighting%2C%20golden%20rim%20light%20accents%2C%20elegant%20classic%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20fine%20art&width=1200&height=600&seq=carousel-tanhua-retro&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '独家策划 · 探花新锐推荐',
    desc: '探花编辑团队精心筛选的新晋优质内容专题，聚焦近期涌现的高品质探花在线资源，每期推荐都经过严格评审。',
    img: 'https://readdy.ai/api/search-image?query=Fresh%20coral%20rose%20and%20soft%20golden%20cinematic%20wide%20abstract%20composition%2C%20modern%20elegant%20flowing%20shapes%20with%20dynamic%20energy%2C%20warm%20radiant%20lighting%2C%20premium%20editorial%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20abstract%20art&width=1200&height=600&seq=carousel-tanhua-editors&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '稀有资源 · 探花珍藏特辑',
    desc: '难得一见的探花稀有资源合集，涵盖多年积累的珍品内容，限时开放浏览，探花资深用户的终极收藏之选。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20amber%20cinematic%20wide%20composition%20with%20golden%20sparkle%20particles%2C%20rich%20premium%20atmosphere%2C%20dramatic%20shadow%20and%20light%20interplay%2C%20luxurious%20velvet%20textures%2C%20exclusive%20rare%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20fine%20art&width=1200&height=600&seq=carousel-tanhua-rare-collection&orientation=landscape',
    tag: '稀有珍藏',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            焦点专题
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
            {slides.map((slide) => (
              <a
                key={slide.title}
                href="#carousel"
                onClick={(e) => e.preventDefault()}
                className="relative rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer group"
              >
                <div className="relative aspect-[2/1] overflow-hidden">
                  <img
                    src={slide.img}
                    alt={slide.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <span className="inline-block px-2.5 py-0.5 text-[10px] font-bold text-white bg-accent-500/90 rounded-full mb-2 whitespace-nowrap">{slide.tag}</span>
                    <h3 className="font-heading text-lg md:text-xl font-bold text-white mb-1.5">{slide.title}</h3>
                    <p className="text-xs md:text-sm text-white/70 leading-relaxed line-clamp-2">{slide.desc}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}